
import { Record, Union } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { FormState__startLoading, FormState__setValidationResponse_5219762A, FormState_get_empty, FormState_$reflection, ClientApiResponse$1_$reflection, RoleId_$reflection } from "../../../Shared/Shared.js";
import { record_type, bool_type, union_type, class_type } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { Cmd_none } from "../../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { Cmd_errorToast, Cmd_successToast } from "../../../Components/Toast.js";
import { Cmd_OfPromise_either } from "../../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../../../CommunicationV2.js";
import { Types_RequestProperties } from "../../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { singleton } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { replace, concat } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { RoleId__get_unwrap } from "../../../Shared/Shared.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { React_useElmish_Z6C327F2E } from "../../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { reactApi } from "../../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { ConfirmationDialog } from "../../../Components/Dialog.js";

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["DeleteRole", "RoleDeleted", "FetchError"];
    }
}

function Msg_$reflection() {
    return union_type("Settings.Roles.Dialogs.RoleDeleteDialog.Msg", [], Msg, () => [[], [["Item", ClientApiResponse$1_$reflection(RoleId_$reflection())]], [["Item", class_type("System.Exception")]]]);
}

class State extends Record {
    constructor(RoleId, FormState, IsDeleted) {
        super();
        this.RoleId = RoleId;
        this.FormState = FormState;
        this.IsDeleted = IsDeleted;
    }
}

function State_$reflection() {
    return record_type("Settings.Roles.Dialogs.RoleDeleteDialog.State", [], State, () => [["RoleId", RoleId_$reflection()], ["FormState", FormState_$reflection()], ["IsDeleted", bool_type]]);
}

function init(roleId) {
    return [new State(roleId, FormState_get_empty(), false), Cmd_none()];
}

function update(msg, state) {
    switch (msg.tag) {
        case 1:
            if (msg.fields[0].tag === 1) {
                return [new State(state.RoleId, FormState__setValidationResponse_5219762A(state.FormState, msg.fields[0].fields[0]), state.IsDeleted), Cmd_none()];
            }
            else {
                return [new State(state.RoleId, FormState_get_empty(), true), Cmd_successToast("settings.roles.deleted")];
            }
        case 2:
            return [new State(state.RoleId, FormState_get_empty(), state.IsDeleted), Cmd_errorToast("general.a_error_occured")];
        default:
            return [new State(state.RoleId, FormState__startLoading(state.FormState), state.IsDeleted), Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                let url_2;
                return ((url_2 = addPrefix(url), (refreshOn) => fetchWithDecoder(url_2, singleton(new Types_RequestProperties(0, ["DELETE"])), "application/json", (response) => {
                    const pr = response.arrayBuffer();
                    return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), RoleId_$reflection()));
                }, refreshOn)))(true);
            })), concat("/api/roles/", ...RoleId__get_unwrap(state.RoleId)), (Item) => (new Msg(1, [Item])), (Item_1) => (new Msg(2, [Item_1])))];
    }
}

export function RoleDeleteDialog(props) {
    let Title;
    const t = useTranslation()[0];
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(init, update, (_arg, _arg_1) => {
    }), props.Definition.Id, undefined);
    const state_1 = patternInput_1[0];
    const dependencies_1 = [state_1.IsDeleted];
    reactApi.useEffect(() => {
        if (state_1.IsDeleted) {
            props.OnDeleted();
        }
    }, dependencies_1);
    return createElement(ConfirmationDialog, (Title = t("settings.roles.delete_title"), {
        Description: replace(t("settings.roles.delete_description"), "{{name}}", props.Definition.Name),
        FormState: state_1.FormState,
        IsOpen: props.IsOpen,
        OnClose: props.OnClose,
        OnConfirm: () => {
            patternInput_1[1](new Msg(0, []));
        },
        Title: Title,
    }));
}

